import cafe24 from "./sites/cafe24/check";
import godomall from "./sites/godomall/check";
import imweb from "./sites/imweb/check";
import makeshop from "./sites/makeshop/check";
import naverSmartstore from "./sites/naver-smartstore/check";
import oopy from "./sites/oopy/check";
import shopbyPro from "./sites/shopby-pro/check";
import shopby from "./sites/shopby/check";
import shopify from "./sites/shopify/check";
import sixshop from "./sites/sixshop/check";
import sixshopPro from "./sites/sixshop-pro/check";
import wix from "./sites/wix/check";
import wordpress from "./sites/wordpress/check";
import type { ExternalSiteCheckRule, IExternalSiteCheckManager } from "./types";

const createExternalSitesCheckManager = () => {
  const sites: ExternalSiteCheckRule[] = [];

  const result: IExternalSiteCheckManager = {
    register: (site) => {
      sites.push(site);
    },

    checkPage: (args) => {
      const foundExternalSite = sites.find(
        (site) => site.type === args.siteType
      );

      if (!foundExternalSite) {
        return false;
      }

      return foundExternalSite.checkPage(args);
    },
  };

  return result;
};

const ExternalSitesCheckManager = createExternalSitesCheckManager();

ExternalSitesCheckManager.register(oopy);
ExternalSitesCheckManager.register(sixshop);
ExternalSitesCheckManager.register(sixshopPro);
ExternalSitesCheckManager.register(makeshop);
ExternalSitesCheckManager.register(imweb);
ExternalSitesCheckManager.register(cafe24);
ExternalSitesCheckManager.register(shopify);
ExternalSitesCheckManager.register(wix);
ExternalSitesCheckManager.register(shopby);
ExternalSitesCheckManager.register(shopbyPro);
ExternalSitesCheckManager.register(godomall);
ExternalSitesCheckManager.register(wordpress);
ExternalSitesCheckManager.register(naverSmartstore);

export default ExternalSitesCheckManager;
